import { View, Text, Image, Dimensions, TouchableOpacity } from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import { white } from "../../colors";
import { useNavigation } from "@react-navigation/native";

export default function CategoryItem({ name, image, id }) {
  const navigation = useNavigation();
  return (
    <View
      style={{
        width: Dimensions.get("window").width / 3 + 10,
        overflow: "hidden",
        margin: 10,
        alignItems: "center",
      }}
    >
      <TouchableOpacity
        onPress={() =>
          navigation.navigate("TutorialCategory", {
            name: name,
            id: id,
          })
        }
        style={{
          marginBottom: 10,
          width: Dimensions.get("window").width / 3,
          height: Dimensions.get("window").width / 3,
          borderRadius: Dimensions.get("window").width / 3,
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          backgroundColor: white,
        }}
      >
        <Image
          source={{ uri: image }}
          style={{
            width: Dimensions.get("window").width / 3 - 5,
            height: Dimensions.get("window").width / 3 - 5,
          }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <MyText style={{ color: white, marginTop: 10, fontSize: 18 }}>
        {name}
      </MyText>
    </View>
  );
}
